import React from 'react';
import Loading from 'react-loader-spinner';
import PropTypes from 'prop-types';
const Loader = ({
  type
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "extender editor"
  }, /*#__PURE__*/React.createElement("div", {
    className: "padder"
  }, /*#__PURE__*/React.createElement(Loading, {
    type: type,
    color: "#e5ccb3",
    height: 100,
    width: 100,
    F: true
  })));
};
Loader.propTypes = {
  type: PropTypes.string.isRequired
};
export default Loader;